import React from 'react';
import styled from 'styled-components';
import {DarkAccentColor,AccentColor,Secondary50,Secondary100,DividerColor, DisableColor} from '../../Colors';

const Button = styled.button`
    border: 1px solid ${DividerColor};
    text-decoration: none;
    text-transform: none;
    text-align: center;
    cursor : pointer;
    border-radius : 5px;
    color : ${AccentColor};
    padding-left : 16px;
    padding-right : 16px;
    &:focus{
        color : ${DarkAccentColor};
        background-color : ${Secondary100};
        outline : 0;
    }
    &:hover{
        color : ${DarkAccentColor};
        background-color : ${Secondary50};
    }
    &:disabled{
        background-color : transparent;
        color : ${DisableColor};
    }
`;



const OutlinedButton = ({...props}) => <Button {...props} />;

export default OutlinedButton;